import React from "react";
import NewsletterTwentyOne from "../component/NewsletterTwentyOne";

function NewsletterTwentyOneContainer() {
  return <NewsletterTwentyOne />;
}

export default NewsletterTwentyOneContainer;
